var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar col-12 col-md-3 col-xl-2 p-0"},[_c('div',{staticClass:"sticky-top"},[_c('img',{staticClass:"p-reset pt-2",attrs:{"src":require("@/assets/svg/logo-horizontal.svg")}}),_c('hr'),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }